module.exports = __webpack_public_path__ + "img/fig09.3e51bfa2.jpg";